import {Route, Routes} from 'react-router-dom';
import Form from './components/forms/Form';
import Greeting from './components/Greeting';

function App() {
  return (
      <div className="App min-h-screen">
        <Routes>
          <Route path='/' element={<Greeting />} />
          <Route path='form' element={<Form />} />
        </Routes>
      </div>
  );
}

export default App;
